module.exports = __webpack_public_path__ + "img/4_4.1ffafcb1.png";